@if (href(); as link) {
  <!-- An anchor has no `disabled`; aria-disabled + tabindex take it out of both pointer and keyboard reach. -->
  <a
    [class]="classes()"
    [href]="link"
    target="_blank"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-disabled]="disabled() || null"
    [attr.tabindex]="disabled() ? -1 : null"
  >
    <ng-container [ngTemplateOutlet]="label" />
  </a>
} @else {
  <button
    [class]="classes()"
    [type]="type()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
  >
    <ng-container [ngTemplateOutlet]="label" />
  </button>
}

<ng-template #label>
  <ng-content />
</ng-template>
